/** Keeps the active collection visible on narrow screens without intercepting links. */
class ClothingNavigation extends HTMLElement {
  #observer;

  connectedCallback() {
    this.#observer = new ResizeObserver(() => this.#revealCurrent());
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #revealCurrent() {
    const track = this.querySelector('ul');
    const current = this.querySelector('[aria-current="page"]');
    if (!track || !current || track.scrollWidth <= track.clientWidth) return;

    const trackBounds = track.getBoundingClientRect();
    const currentBounds = current.getBoundingClientRect();
    track.scrollLeft += currentBounds.left - trackBounds.left - (trackBounds.width - currentBounds.width) / 2;
  }
}

if (!customElements.get('plch-clothing-navigation')) {
  customElements.define('plch-clothing-navigation', ClothingNavigation);
}
